<h1
  mat-dialog-title
  translate="UI.USER.LINKED_ACCOUNTS.NEW_MASTER_DIALOG.TITLE"
></h1>

<div mat-dialog-content>
  <p translate="UI.USER.LINKED_ACCOUNTS.NEW_MASTER_DIALOG.HELP"></p>
  <shared-form-editor [config]="config"></shared-form-editor>
</div>
